import React from 'react'
import {
  SuccessCircle,
  ErrorCircle,
  InfoIcon,
  CircleIcon,
} from 'shared/ui/Icons'
import { STEPS } from 'domain/enums'
import { bool, number, shape, string } from 'prop-types'
import { formatDate, proposalStepKeys } from 'shared/helpers'
import {
  StepCard as Step,
  StepContent,
  StepTitle,
  StepSubtitle,
} from './Lead.styles'

const StepCard = ({ step, isCurrentStep }) => {
  const pickIcon = ({ rejectionReason, progress }) => {
    if (rejectionReason) return <ErrorCircle />
    if (progress.finishedAt) return <SuccessCircle />
    return progress.startedAt ? <InfoIcon /> : <CircleIcon />
  }

  const mountDescription = ({ name, rejectionReason, progress }) => {
    if (rejectionReason) return 'A proposta foi negada'
    if (name === proposalStepKeys.PROPOSAL_CREATED)
      return `Concluída em ${formatDate(progress.startedAt)}`
    if (progress.finishedAt)
      return `Concluída em ${formatDate(progress.finishedAt)}`

    return progress.startedAt ? 'Em andamento' : ''
  }

  return step ? (
    <Step current={isCurrentStep} data-testid={`step-${step.order}`}>
      {pickIcon(step)}
      <StepContent>
        <StepTitle hasStarted={Boolean(step.progress.startedAt)}>
          {STEPS[step.name]}
        </StepTitle>
        <StepSubtitle data-testid="step-description">
          {mountDescription(step)}
        </StepSubtitle>
      </StepContent>
    </Step>
  ) : null
}

StepCard.propTypes = {
  step: shape({
    name: string,
    order: number,
    progress: shape({
      startedAt: string,
      finishedAt: string,
    }),
    rejectionReason: string,
  }),
  isCurrentStep: bool,
}

export { StepCard }
